import { useEffect, useRef } from 'react';
import TagManager from 'react-gtm-module';
import { useStepsContext } from '../../Hooks/useStepsContext';
import { redirect } from '../../Utils/functions';
import { laneCopy } from '../../Utils/laneCopy';
import BotResponse from '../BotResponse/BotResponse';
import Button from '../Button/Button';
import classes from 'classnames';

const VIDA_HOME = 'https://www.vidaselect.com';

/**
 * Step 16 — free-database registration confirmation.
 *
 * Reached right after the opt-in (step 15) saves the lead. Visually analogous to the opt-in screen
 * (same BotResponse bubbles), but purely informational: it confirms the visitor is registered in
 * VIDA's member network and offers a single button to the VIDA Select home. No input and no Back —
 * the record is already saved, so there is nothing to edit or resubmit.
 *
 * Every sentence comes from laneCopy.belowFloor.confirmation; this file contributes no wording.
 *
 * @author Cristian David
 * @since 2026-09-24
 */
export default function FreeDatabaseConfirmation() {
  const { state, animate, stepPassed } = useStepsContext();
  const { name } = state;
  const copy = laneCopy.belowFloor.confirmation;
  const isTestLead = (name || '').toLowerCase().includes('test');

  // View event, kept to one push by the ref (StrictMode double-invokes effects in dev). Mirrors the
  // opt-in screen's view event so the funnel's free-database steps report consistently.
  const viewFired = useRef(false);
  useEffect(() => {
    if (stepPassed || isTestLead || viewFired.current) return;
    viewFired.current = true;

    TagManager.dataLayer({
      dataLayer: {
        event: 'allybot2_free_db_confirmation_page',
        allybot2_disclosure_copy_id: laneCopy.belowFloor.copyId,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div name="freeDatabaseConfirmation">
      {copy.body.map((line, i) => (
        <BotResponse key={line} className={classes(animate(i), 'mb-20px')}>
          {line.replace('{name}', name || '')}
        </BotResponse>
      ))}

      <div className="frm_submit align-to-message">
        <Button label={copy.buttonLabel} className="auto-width" onClick={() => redirect(VIDA_HOME)} />
      </div>
    </div>
  );
}
